import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'
import { useT } from '../../lib/i18n'
import useReducedMotion from '../../hooks/useReducedMotion'

const ease = [0.22, 1, 0.36, 1]

export default function HeroCTA() {
  const t = useT()
  const reduced = useReducedMotion()

  return (
    <motion.div
      className="flex flex-col items-center gap-4"
      initial={reduced ? false : { opacity: 0, y: 16 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6, delay: 0.8, ease }}
    >
      <Link
        to="/royxatdan-otish"
        className="cta-glow inline-flex items-center justify-center px-10 py-4 md:px-14 md:py-5 bg-white text-[var(--color-indigo-800)] font-bold tracking-[0.18em] text-sm md:text-base rounded-[var(--radius-md)] shadow-[var(--shadow-card)] hover:bg-white/95 active:scale-[0.98] transition-all"
      >
        {t('cta.register')}
      </Link>
      <span className="text-xs md:text-sm font-medium uppercase tracking-[0.3em] text-[var(--color-ink-muted)] mt-1">
        {t('hero.domain')}
      </span>
    </motion.div>
  )
}
